import { useCallback } from 'react';
import * as notificationService from '../services/notificationService';

// Hook específico para notificaciones
export function useNotifications() {
  const getAllNotifications = useCallback(async () => {
    return await notificationService.getNotifications();
  }, []);

  const getNotificationCount = useCallback(async () => {
    return await notificationService.getNotificationCount();
  }, []);

  const markAsRead = useCallback(async (id: string) => {
    return await notificationService.markNotificationAsRead(id);
  }, []);

  const markAsUnread = useCallback(async (id: string) => {
    return await notificationService.markNotificationAsUnread(id);
  }, []);

  const markAllAsRead = useCallback(async () => {
    return await notificationService.markAllNotificationsAsRead();
  }, []);

  const deleteNotification = useCallback(async (id: string) => {
    return await notificationService.deleteNotification(id);
  }, []);

  return {
    getAllNotifications,
    getNotificationCount,
    markAsRead,
    markAsUnread,
    markAllAsRead,
    deleteNotification,
  };
}
